import { Directive } from '../classes';

declare function startingTag(element: JQuery): string;
declare function ngTranscludeMinErr(...args: any[]): void;

export class TranscludeReplaceComponent extends Directive {
    public static get $name() {
        return 'transcludeReplace';
    }

    public static get $terminal() {
        return true;
    }

    public static get $inject() {
        return ['$compile'];
    }

    constructor(private $compile: any) {
        super();
    }

    public compile(tElement: JQuery) {
        const fallbackLinkFn = this.$compile(tElement.contents());
        tElement.empty();

        return function ngTranscludePostLink($scope: angular.IScope, $element: JQuery, $attrs: any, _controller: any, $transclude: any) {
            if (!$transclude) {
                throw ngTranscludeMinErr(
                    'orphan',
                    'Illegal use of ngTransclude directive in the template! ' +
                        'No parent directive that requires a transclusion found. ' +
                        'Element: {0}',
                    startingTag($element)
                );
            }

            if ($attrs.transcludeReplace === $attrs.$attr.transcludeReplace) {
                $attrs.transcludeReplace = '';
            }

            const slotName = $attrs['transcludedSlot'];

            $transclude(ngTranscludeCloneAttachFn, null, slotName);

            if (slotName && !$transclude.isSlotFilled(slotName)) {
                useFallbackContent();
            }

            function ngTranscludeCloneAttachFn(clone: JQuery, transcludedScope: angular.IScope) {
                if (clone.length) {
                    $element.replaceWith(clone);
                    clone.attr('class', $element.attr('transcluded-classes')!);
                } else {
                    useFallbackContent();
                    transcludedScope.$destroy();
                }
            }

            function useFallbackContent() {
                fallbackLinkFn($scope, function (clone: JQuery) {
                    $element.replaceWith(clone);
                    clone.attr('class', $element.attr('transcluded-classes')!);
                });
            }
        };
    }
}
